module.exports = __webpack_public_path__ + "img/wechatThird.08fc50f8.png";